import { createStoreFromUrl, BaseApiService, http, MessageBool } from "../base";
import { BottleModel } from "../models";

class BottleService extends BaseApiService<BottleModel> {
    moduleName = "bottle";

    getDxData(isPorcelainCode?: boolean) {
        return createStoreFromUrl(`${this.apiPath}/dx` + 
            (typeof(isPorcelainCode) === "boolean" ? `?isPorcelainCode=${isPorcelainCode}` : ''), 'id');
    }

    publicGetByCode(code: string) {
        return http.getData<BottleModel>(`${this.apiPath}/public?code=${code}`);
    }

    logicDelete(ids: number[]) {
        return http.putData<MessageBool>(`${this.apiPath}/logicdelete`, ids);
    }

    restore(ids: number[]) {
        return http.putData<MessageBool>(`${this.apiPath}/restore`, ids);
    }
}

export const bottleService = new BottleService();
export const bottleStore = bottleService.getDxData();